/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_Q1Inputs */

const en_directory_home_faq_q1 = /** @type {(inputs: Directory_Home_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Seek AI?`)
};

const zh_directory_home_faq_q1 = /** @type {(inputs: Directory_Home_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 是什么？`)
};

/**
* | output |
* | --- |
* | "What is Seek AI?" |
*
* @param {Directory_Home_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_q1 = /** @type {((inputs?: Directory_Home_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_q1(inputs)
	return zh_directory_home_faq_q1(inputs)
});
export { directory_home_faq_q1 as "directory.home.faq.q1" }